/* eslint-disable @typescript-eslint/no-explicit-any */
// order-flow.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, timeout, catchError } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { OrderSummaryResponse } from '../../model/order-summary-response.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderFlowService {

  private readonly REQUEST_TIMEOUT = 100000; // 10 segundos

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  
  createOrder(payload: any[]): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/order-details`;

    return this.http.post(endpoint, payload, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error creating order'))
    );
  }

  getOrderSummary(orderNumber: string): Observable<OrderSummaryResponse> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/${orderNumber}/summary`;

    return this.http.get<OrderSummaryResponse>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching order summary'))
    );
  }

  getOrderToEdit(orderNumber: string){
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/${orderNumber}`;

    return this.http.get<any>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching order detail sources'))
    );
  }

  getBaseOrderDetailToDuplicate(orderNumber: string): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/order-detail-sources?baseOrderNumber=${orderNumber}`;

    return this.http.get<any>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching order detail sources'))
    );
  }

   getProductChoiceToDuplicate(baseOrderNumber: string): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/product-choice?baseOrderNumber=${baseOrderNumber}`;

    return this.http.get<any>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching order detail sources'))
    );
  }

  addProductsToOrderToDuplicate(baseOrderNumber: string, payload: any): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/order-products?baseOrderNumber=${baseOrderNumber}`;

    return this.http.post(endpoint, payload, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error adding products to order'))
    );
  }

  // Método para adicionar produtos ao pedido
  addProductsToOrder(payload: any): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/order-products`;

    return this.http.post(endpoint, payload, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error adding products to order'))
    );
  }

  // Método para obter fontes de detalhes do pedido
  getOrderDetailSources(): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/order-detail-sources`;

    return this.http.get<any>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching order detail sources'))
    );
  }

  // Método para obter opções de produto
  getProductChoice(): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.webview}/product-choice`;

    return this.http.get<any>(endpoint, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error fetching product choices'))
    );
  }

  // Método para enviar medições do pedido
  submitOrder(payload: any): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/submit-order`;

    return this.http.post(endpoint, payload, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error to submit order'))
    );
  }

  quoteOrder(payload: any, orderNumber: string, quoteType: string): Observable<any> {
    const headers = this.authService.getHeaders();
    const endpoint = `${environment.api}/v1/orders/quote-order?orderNumber=${orderNumber}&quoteType=${encodeURIComponent(quoteType)}`;

    return this.http.post(endpoint, payload, {  headers,
    responseType: 'blob',
    observe: 'response'
  }).pipe(
        timeout(this.REQUEST_TIMEOUT),
        catchError(this.handleError('Error to submit order'))
      );
  }

  saveOrder(payload: any, status?: string): Observable<any> {
    const headers = this.authService.getHeaders();
    let endpoint = `${environment.api}/v1/orders/save-order`;
    
    if (status !== null && status !== undefined) {
      endpoint += `?status=${encodeURIComponent(status)}`;
    }

    return this.http.post(endpoint, payload, { headers }).pipe(
      timeout(this.REQUEST_TIMEOUT),
      catchError(this.handleError('Error to save order'))
    );
  }

  // Método auxiliar para tratar erros
  private handleError(operation: string) {
    return (error: any): Observable<never> => {
      console.error(`${operation}:`, error);
      return throwError(() => new Error('Something went wrong; please try again later.'));
    };
  }
}